var _defs, _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 7,
    y1: 50.5,
    x2: 93,
    y2: 50.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcd05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#e2c70f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#019966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095d6"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: url(#g1);stroke-width: 8 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m68.1 16.6l-15.1-9.2c-0.9-0.6-2.1-0.6-3-0.1l-35.1 20.4c-0.9 0.6-0.9 1.9 0 2.5l32.7 19.9c0.8 0.4 1.7 0.5 2.5 0l36.4-20.1c1.1-0.6 2.5 0.2 2.5 1.4v37.5c0 2.2-1.2 4.3-3.1 5.4l-31.5 18.8c-2.2 1.2-4.8 1.3-7 0.1l-34.4-18.6c-1.2-0.7-2-1.9-2-3.3v-15.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4fba987647bae4139a3c6726a339e60a.svg";
export { ForwardRef as ReactComponent };